export default __webpack_public_path__ + "static/media/information.ec886e0a.svg";